import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=d2f72bcc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=d2f72bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f72bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2f72bcc')) {
      api.createRecord('d2f72bcc', component.options)
    } else {
      api.reload('d2f72bcc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=d2f72bcc&scoped=true&", function () {
      api.rerender('d2f72bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XfSweHEg8jRA/JS/comp/PopupBox.vue"
export default component.exports